import { render, staticRenderFns } from "./VehicleContent.vue?vue&type=template&id=29cdab54&scoped=true"
import script from "./VehicleContent.vue?vue&type=script&lang=ts"
export * from "./VehicleContent.vue?vue&type=script&lang=ts"
import style0 from "./VehicleContent.vue?vue&type=style&index=0&id=29cdab54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cdab54",
  null
  
)

export default component.exports